import { ButtonHTMLAttributes, forwardRef } from 'react';
import { Icon, IconName } from '../icons';
import { Spinner } from '../spinner';
import { IconWrapper, StyledButton } from './styled';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'alert';
  size?: 'large' | 'medium' | 'small';
  icon?: IconName;
  iconPosition?: 'left' | 'right';
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = 'primary',
      size = 'medium',
      disabled = false,
      icon,
      iconPosition = 'left',
      loading,
      fullWidth,
      ...props
    },
    ref
  ): JSX.Element => {
    return (
      <StyledButton
        ref={ref}
        disabled={disabled}
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        {...props}
      >
        {(typeof icon !== 'undefined' || loading === true) && (
          <IconWrapper
            position={iconPosition}
            noMargin={
              typeof children === 'undefined' ||
              children === null ||
              children === ''
            }
          >
            {loading !== true && <Icon name={icon as IconName} />}
            {loading === true && <Spinner />}
          </IconWrapper>
        )}
        <span style={{ order: iconPosition === 'right' ? 1 : 2 }}>
          {children}
        </span>
      </StyledButton>
    );
  }
);
